/**
 * One presence rule for every surface (dashboard, launcher, bridge, Telegram relay):
 * an agent is online when a client on a member's machine, bound to it, heartbeated
 * recently. The server-managed dashboard session is never presence, it exists for
 * every user all the time.
 */
export const LOCAL_CLIENT_KINDS = ["claude", "codex"];
/** How long after its last heartbeat a local session still counts as online. */
export const PRESENCE_WINDOW_MS = 90_000;
/** True for a client kind that runs on a member's machine; false for "dashboard" and anything unknown. */
export function isLocalClient(kind) {
    return LOCAL_CLIENT_KINDS.includes(kind);
}
/**
 * Latest local-client session bound to `agentId`; online when its heartbeat is within
 * `windowMs` and not in the future (a clock ahead of ours must not read as alive).
 */
export function agentPresence(agentId, sessions, now = Date.now(), windowMs = PRESENCE_WINDOW_MS) {
    const bound = sessions
        .filter((session) => boundAgentOf(session) === agentId && isLocalClient(session.client))
        .sort((left, right) => right.heartbeatAt.localeCompare(left.heartbeatAt));
    const latest = bound[0];
    if (!latest)
        return { online: false, client: null, heartbeatAt: null };
    const age = now - Date.parse(latest.heartbeatAt);
    return { online: age >= 0 && age < windowMs, client: latest.client, heartbeatAt: latest.heartbeatAt };
}
function boundAgentOf(session) {
    return "boundAgentId" in session ? session.boundAgentId : session.agentId;
}
//# sourceMappingURL=presence.js.map